import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    hoverEffect?: boolean;
    gradientBorder?: boolean;
    onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
    children,
    className = '',
    hoverEffect = false,
    gradientBorder = false,
    onClick,
}) => {
    // Noise texture SVG for subtle grain overlay
    const noisePattern = `data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.05'/%3E%3C/svg%3E`;

    if (gradientBorder) {
        return (
            <div
                className={`group relative rounded-2xl bg-gradient-to-r from-brand/20 via-info/20 to-brand/20 p-px animate-border-shimmer bg-[length:200%_100%] ${className}`}
                onClick={onClick}
            >
                <div className="relative h-full w-full rounded-2xl bg-white/[0.02] backdrop-blur-xl overflow-hidden">
                    {/* Noise texture overlay */}
                    <div
                        className="absolute inset-0 opacity-[0.015] pointer-events-none"
                        style={{
                            backgroundImage: `url("${noisePattern}")`,
                            backgroundSize: '200px 200px'
                        }}
                    />

                    {/* Inner shadow for depth */}
                    <div className="absolute inset-0 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.03)] rounded-2xl pointer-events-none" />

                    {/* Content */}
                    <div className="relative z-10">
                        {children}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className={`
                relative rounded-2xl bg-white/[0.02] backdrop-blur-xl
                border border-white/[0.06]
                shadow-[inset_0_1px_0_0_rgba(255,255,255,0.03)]
                overflow-hidden
                ${hoverEffect ? 'hover:bg-white/[0.04] hover:border-white/[0.1] hover:shadow-xl hover:shadow-black/20 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer' : ''}
                ${className}
            `}
            onClick={onClick}
        >
            {/* Noise texture overlay */}
            <div
                className="absolute inset-0 opacity-[0.015] pointer-events-none"
                style={{
                    backgroundImage: `url("${noisePattern}")`,
                    backgroundSize: '200px 200px'
                }}
            />

            {/* Content */}
            <div className="relative z-10">
                {children}
            </div>
        </div>
    );
};
